var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapseAdviserSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90906 10.0909C8.90906 6.65442 11.6847 4.5 15.1212 4.5C18.5577 4.5 21.3333 7.27563 21.3333 10.7121",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59844 8.84848H7.97723C7.80569 8.84848 7.66663 9.07099 7.66663 9.34545V13.3212C7.66663 13.5957 7.80569 13.8182 7.97723 13.8182H8.59844C8.76999 13.8182 8.90905 13.5957 8.90905 13.3212V9.34545C8.90905 9.07099 8.76999 8.84848 8.59844 8.84848Z",
    fill: "#F4F4F9",
    stroke: "#F4F4F9",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2652 8.84848H21.644C21.4724 8.84848 21.3334 9.07099 21.3334 9.34545V13.3212C21.3334 13.5957 21.4724 13.8182 21.644 13.8182H22.2652C22.4367 13.8182 22.5758 13.5957 22.5758 13.3212V9.34545C22.5758 9.07099 22.4367 8.84848 22.2652 8.84848Z",
    fill: "#F4F4F9",
    stroke: "#F4F4F9",
    strokeWidth: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9545 14.4394C21.9545 17.2428 19.3025 20.2788 16.6742 20.2788H15.1212",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0087 19.0364H14.2338C14.0377 19.0364 13.8788 19.1754 13.8788 19.347V19.9682C13.8788 20.1397 14.0377 20.2788 14.2338 20.2788H16.0087C16.2047 20.2788 16.3636 20.1397 16.3636 19.9682V19.347C16.3636 19.1754 16.2047 19.0364 16.0087 19.0364Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15C17.2091 15 19 13.2091 19 11C19 8.79086 17.2091 7 15 7C12.7909 7 11 8.79086 11 11C11 13.2091 12.7909 15 15 15Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17.1275C20.5264 17.1275 22.0821 21.0901 22.4837 23.1359C22.6122 23.7904 21.9622 24.3275 21.1465 24.3275H7.85352C7.03779 24.3275 6.38779 23.7904 6.51626 23.1359C6.91783 21.0901 8.4735 17.1275 14.5 17.1275Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseAdviserSupport);
export default __webpack_public_path__ + "static/media/CollapseAdviserSupport.228a24e26f2f295758e5c0b7d664a162.svg";
export { ForwardRef as ReactComponent };